import { render } from "./Descripcion.vue?vue&type=template&id=63650aff&scoped=true"
import script from "./Descripcion.vue?vue&type=script&lang=js"
export * from "./Descripcion.vue?vue&type=script&lang=js"

import "./Descripcion.vue?vue&type=style&index=0&id=63650aff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63650aff"]])

export default __exports__